export default {
  id: '6',
  title: '认知症高风险防治服务',
  createTime: '2025-03-22 10:00:00',
  content: `![img](https://cdn.keihong.tech/img/20250422161658913.png)

适合客户：针对认知症高风险，希望减缓认知症恶化的人士。

服务时长：12个月

服务权益：

1） **全套智能设备**：远程康复仪、运动工具包和5种智能身体检测设备，配合脑健康训练程序。
2） **专业评估指导**：首诊免费，每月2次视频问诊（20分钟/次），定制训练方案。
3） **系统健脑服务**：每月提供2套个性化居家训练方案，配合数字人亲情陪伴。
4） **效果全程监测**：每季度一次康复效果评定（共4次），确保训练有效性。
5） **终身健康守护**：提供终身客户线上咨询与随访，持续脑健康管理。

咨询电话：18520535303

添加二维码：

![img](https://cdn.keihong.tech/img/20250422161658865.png)`
}
